export default "<p>acompanhamento-sangria-geral-detail works!</p>\n";